import React from 'react';
import './SmsConsent.css';

const SmsConsent = () => {
  return (
    <div className="sms-consent-page">
      <div className="sms-consent-card">
        <h1>SMS Consent</h1>
        <p className="sms-consent-intro">
          MarkazSync sends SMS messages to parents/guardians about attendance, schedule updates,
          school/markaz cancellations, and account notifications.
        </p>

        <h2>How Parents Consent</h2>
        <p>
          Parents/guardians opt in at enrollment by signing a consent section on the registration
          form. Admins enter the parent’s name and phone number into MarkazSync only after consent
          is collected.
        </p>

        <h2>Consent Language</h2>
        <div className="sms-consent-quote">
          “I agree to receive SMS messages from MarkazSync about attendance, schedule updates, and
          school/markaz cancellations, and account notifications. Message frequency varies.
          Msg&amp;data rates may apply. Reply STOP to opt out, HELP for help.”
        </div>

        <h2>Opt-Out</h2>
        <p>
          Users may opt out anytime by replying STOP. Opt-out is honored immediately.
        </p>
      </div>
    </div>
  );
};

export default SmsConsent;
